import type { RouteMeta } from 'vue-router';

import { adminEnumRoutes } from '@/routes/admin/admin.enum.routes';

export const AdminMenuItems: {
  path: string;
  name: string;
  meta: RouteMeta;
}[] = [
  adminEnumRoutes.dashboard,
  adminEnumRoutes.users,
  adminEnumRoutes.teams,
  adminEnumRoutes.journeys,
  adminEnumRoutes.courses,
  adminEnumRoutes.LearningCategories,
  adminEnumRoutes.registrationRequest,
  adminEnumRoutes.approvals,
  adminEnumRoutes.grades,
  adminEnumRoutes.socialPlatform,
  adminEnumRoutes.events,
  adminEnumRoutes.transactions,
  adminEnumRoutes.refunds,
  adminEnumRoutes.transferToBankRequest,
  adminEnumRoutes.announcements,
  adminEnumRoutes.newsLetters,
  adminEnumRoutes.articles,
  adminEnumRoutes.wallets,
  adminEnumRoutes.conversionRate,
  adminEnumRoutes.issuedCertificates,
  adminEnumRoutes.assessments,
  adminEnumRoutes.permissions,
  adminEnumRoutes.supportTickets,
  adminEnumRoutes.organizationOverview,
];
